import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { states } from '../../shared/static/states';
import { CITIES } from '../../shared/static/cities.json';
import { MembersService } from '../members.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GroupService } from 'src/app/group/group.service';
import { MatDialog } from '@angular/material/dialog';
import { getFileUrl } from 'src/app/utils/getFileUrl';
import { MembersFileSendComponent } from '../members-file-send/members-file-send.component';
import { User } from 'src/app/shared/interfaces/user.interface';
import { LoaderService } from 'src/app/components/loader/service/loader.service';

@Component({
  selector: 'app-member-form',
  templateUrl: './member-form.component.html',
  styleUrls: ['./member-form.component.css'],
})
export class MemberFormComponent implements OnInit {
  form: FormGroup;
  genders = [
    { title: 'Masculino', value: 'M' },
    { title: 'Feminino', value: 'F' },
  ];
  bloods = ['A+', 'B+', 'O+', 'AB+', 'A-', 'B-', 'O-', 'AB-'];
  churchStatuses = [
    { title: 'Novo convertido', value: 'novo_convertido' },
    { title: 'Membro', value: 'membro' },
    { title: 'Visitante de célula', value: 'visitante_de_celula' }
  ];
  states = states;
  cities = [];
  groups = [];
  id: string;
  functions = [];
  currentAvatar: string;
  members: User[] = [];
  discipler: any = null;

  constructor(
    private memberService: MembersService,
    private activeRouter: ActivatedRoute,
    private toastr: ToastrService,
    private groupService: GroupService,
    private router: Router,
    private matDialog: MatDialog,
    private loadService: LoaderService
  ) {
    this.activeRouter.params.subscribe((params: Params) => {
      this.getGroups();
      if (params.id) {
        this.id = params.id;
        this.loadUser();
      }
    });

    this.getFuncions();
    this.states = states;

    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      gender: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      phone_number: new FormControl('', [Validators.required]),
      bhirth_date: new FormControl('', [Validators.required, Validators.maxLength(10)]),
      state_id: new FormControl('', []),
      city_id: new FormControl('', []),
      street: new FormControl('', [Validators.required, Validators.minLength(5)]),
      home_number: new FormControl('', [Validators.required]),
      complement: new FormControl('', []),
      blood_type: new FormControl(''),
      cpf: new FormControl(null, [Validators.required]),
      group_id: new FormControl('', []),
      discipler_id: new FormControl('', []),
      group_function_id: new FormControl('', []),
      cep: new FormControl('', [Validators.required, Validators.minLength(9)]),
      church_status: new FormControl('membro', [Validators.required]),
    });
  }

  ngOnInit(): void {}

  loadUser() {
    this.loadService.showLoader();
    this.memberService
      .getById(this.id)
      .then((res) => {
        var {
          name,
          gender,
          email,
          phone_number,
          bhirth_date,
          state_id,
          city_id,
          street,
          home_number,
          complement,
          blood_type,
          cpf,
          group_id,
          discipler_id,
          group_function_id,
          cep,
          church_status,
        } = res;

        if (discipler_id !== null) this.getDiscipler(discipler_id);
        bhirth_date = String(bhirth_date).substr(0, 10);
        this.form.setValue({
          name,
          gender,
          email,
          phone_number,
          bhirth_date,
          city_id,
          state_id,
          street,
          home_number,
          complement,
          blood_type,
          cpf,
          group_id,
          discipler_id,
          group_function_id,
          cep,
          church_status: church_status || 'membro',
        });
        this.currentAvatar = getFileUrl(res);
        this.loadService.closeLoader();
      })
      .catch((err) => {
        this.toastr.error(err.error.message);
        this.loadService.closeLoader();
      });
  }

  getFuncions(): Promise<any> {
    return this.groupService
      .getGroupFunctions()
      .then((res) => {
        this.functions = res;
      })
      .catch((err) => {
        this.toastr.error(err.error.message || 'Algo de errado aconteceu!');
      });
  }

  clearDiscipler() {
    this.discipler = null;
  }

  findByCECID(CECID: any) {
    this.memberService.getByCECID(CECID).then((res) => {
      this.discipler = res[0];
    });
  }

  changeCity(CurrentState): void {
    if (CurrentState) {
      const citiesTemp = CITIES.filter((s) => {
        if (s.Estado == CurrentState) {
          return s;
        }
      });
      this.cities = citiesTemp;
    }
  }

  register(): void {
    this.form.controls['discipler_id'].setValue(this.discipler.cec_id);
    this.form.updateValueAndValidity();
    if (!this.form.valid) {
      this.form.errors;
      return;
    }
    this.memberService
      .addUser(this.form.value)
      .then((res) => {
        this.toastr.success(res.message);
        this.form.reset();
        this.router.navigateByUrl('membro');
      })
      .catch((err) => {
        this.toastr.error(err.error.message || 'Algo de errado aconteceu!');
      });
  }

  getDiscipler(id: string) {
    this.memberService.getById(id).then((res) => {
      const { name, cec_id } = res;
      this.discipler = { name, cec_id };
    });
  }

  update(): void {
    if (this.discipler) {
      this.form.controls['discipler_id'].setValue(this.discipler?.cec_id);
    }
    this.form.updateValueAndValidity();
    if (!this.form.valid) {
      this.form.errors;
      return;
    }
    this.memberService
      .updateUser(this.form.value, this.id)
      .then((res) => {
        this.toastr.success(res.message);
        this.form.reset();
        this.router.navigateByUrl('membro');
      })
      .catch((err) => {
        this.toastr.error();
      });
  }

  getGroups(): Promise<any> {
    return this.groupService
      .get()
      .then((res) => {
        this.groups = res;
      })
      .catch((err) => {
        this.toastr.error(err.error.message || 'Falha ao carregar células');
      });
  }

  changeAvatar() {
    const dialog = this.matDialog
      .open(MembersFileSendComponent, {
        width: '400px',
        height: '600px',
        data: {
          id: this.id,
        },
      })
      .afterClosed()
      .subscribe((afterClosedResult) => {
        afterClosedResult ? this.loadUser() : null;
      });
  }
}
